import Lead from "@/model/Lead";
import Pagination from "@/model/Pagination";
import Axios from "@/utils/axios/Axios";
import ENV from "@/utils/constants/environment";

const RESOURCE_NAME = "contract";

const COUPON_NAME = "outlet/historyCoupons";

export default {
  navigateToContract(request: any) {
    return Axios().post(ENV.API_URL + RESOURCE_NAME + "/navigate", request);
  },

  sendContract(request: any) {
    return Axios().post(ENV.API_URL + RESOURCE_NAME, request);
  },

  checkContract(request: any){
    return Axios().get(ENV.API_URL + RESOURCE_NAME + "/" + request.idCircuit);
  },
  findAll(pagination: Pagination, params: any) {

    let fechaDesde = "";
    let fechaHasta = "";
    
    if(params.fecha != null && params.fecha != undefined){
      fechaDesde = params.fecha[0];
      fechaHasta = params.fecha[1];
    }
    
    return Axios().get(ENV.API_URL + "lead/contractList", {
      params: {
        page: pagination.page,
        cups: params.cups,
        nombre: params.name,
        producto: params.product,
        direccion: params.address,
        estado: params.state,
        email: params.email,
        fechaDesde: fechaDesde,
        fechaHasta: fechaHasta,
        lenght: pagination.size,
        start: (pagination.page * 50)
      }
    });
  },
  findCoupons(request: any){
    return Axios().get(ENV.API_URL + COUPON_NAME, request);
  }
};
